import React from "react";
import { BooleanInput, Button, NumberInput, useGetList, useNotify } from "react-admin";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { Grid } from "@mui/material";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { studentRequests } from "api/studentApi";
import { validateOptionalGrade } from "utils/validations";
import PracticeInput from "./PracticeInput";
import SemesterInput from "./SemesterInput";

// The backend upserts on (practiceId, semester), so one dialog covers both add and edit.
const SavePracticeResultDialog = ({
  educationId,
  curriculumId,
  practiceResult,
  practiceResults = [],
  fetchPracticeResults,
}) => {
  const notify = useNotify();
  const isEdit = !!practiceResult;

  const handleConfirm = async ({ practiceId, semester, completed, grade }) => {
    const isTaken = practiceResults.some(
      result => result.practiceId === practiceId && result.semester === Number(semester),
    );
    if (!isEdit && isTaken) {
      notify("Вече има въведен резултат за тази практика и семестър!", { type: "error" });
      return false;
    }

    await dataProvider.customRequest(
      studentRequests.saveStudentPracticeResult(educationId, practiceId, semester),
      { completed: !!completed, grade: grade === "" || grade == null ? null : Number(grade) },
      "PUT",
    );
    notify(
      isEdit ? "Успешно редактирахте резултат от учебна практика" : "Успешно добавихте резултат от учебна практика",
      { type: "success" },
    );
    fetchPracticeResults();
  };

  const { data: practices } = useGetList(
    studentRequests.getCurriculumPracticesSelect(curriculumId),
    { pagination: { page: 1, perPage: 1000 }, sort: { field: "name", order: "ASC" } },
    { enabled: !!curriculumId },
  );

  return (
    <FormModal
      titleContent={isEdit ? "Редактирай резултат от учебна практика" : "Добави резултат от учебна практика"}
      dialogSize="md"
      onConfirm={handleConfirm}
      defaultValues={{
        practiceId: practiceResult?.practiceId ?? null,
        semester: practiceResult?.semester ?? null,
        completed: !!practiceResult?.completed,
        grade: practiceResult?.grade ?? null,
      }}
      triggerButton={
        <Button
          label={isEdit ? "Редактирай" : "Добави резултат от практика"}
          startIcon={isEdit ? <EditIcon /> : <AddIcon />}
          variant="contained"
          size="small"
        />
      }
    >
      <Grid
        container
        columnSpacing={2}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <PracticeInput
            choices={practices ?? []}
            readOnly={isEdit}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <SemesterInput
            practices={practices ?? []}
            readOnly={isEdit}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={2}
        >
          <NumberInput
            source="grade"
            label="Оценка"
            min={2}
            max={6}
            step={0.01}
            validate={validateOptionalGrade}
            parse={value => (value === "" ? null : parseFloat(value))}
            onWheel={e => e.target.blur()}
            fullWidth
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
        >
          <BooleanInput
            source="completed"
            label="Завършена"
          />
        </Grid>
      </Grid>
    </FormModal>
  );
};

export default SavePracticeResultDialog;
